export default __webpack_public_path__ + "static/media/azure-ad.5c09e97d.png";